import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  code: string;
}

const DocStatusBadge: React.FC<Props> = ({ code }) => {
  const { t } = useTranslation();

  const prefixes = ['SR_ESPF_', 'INIT_ESRS_', 'ESS_', 'ESMR_', 'SR_', 'ESRS_'];
  const status =
    code == null
      ? null
      : (() => {
          const prefix = prefixes.find((p) => code.startsWith(p));
          return prefix ? code.substring(prefix.length) : code;
        })();

  return (
    <div className={`badge-base docstatus ${status}`}>
      <div className="badge-text">
        <span>{t(`esgDocumentStatus.${code}`, code)}</span>
      </div>
    </div>
  );
};

export default React.memo(DocStatusBadge);
